import {Component, OnInit} from '@angular/core';
import {BaseService} from "../services/base.service";

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrl: './base.component.scss'
})
export class BaseComponent implements OnInit {

  constructor(private baseService: BaseService) {
  }

  ngOnInit() { }
}
